import { defineMessages, type MessageValue } from 'react-intl';

export const reorderOrderLineItemMessages = defineMessages<{
  readonly successfulReorderMessage: {
    readonly product: MessageValue;
    readonly quantity: MessageValue;
  };
}>({
  successfulReorderMessage: {
    defaultMessage: '{quantity}x {product} added to your bag!',
    description: 'Reorder | Successful reorder message',
  },
});
